import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { communicationPreferencesSaga } from './communication-preferences-saga';
import { languagesSaga } from './languages-saga';
import {
    communicationPreferencesSagaActionTypes,
    languagesSagaActionTypes
} from '@constants/actionTypes/dashboardActionTypes';

const { FETCH_COMMUNICATION_PREFERENCES } = communicationPreferencesSagaActionTypes;
const { FETCH_LANGUAGES } = languagesSagaActionTypes;

export default function* (): Generator<ForkEffect<never>, void> {
    yield takeEvery(FETCH_COMMUNICATION_PREFERENCES, communicationPreferencesSaga);
    yield takeEvery(FETCH_LANGUAGES, languagesSaga);
}